import { getGlobalStore } from '@mimir/web/store';
import type { ItemWithSourceMedia } from '@mimir/client-common/upload/premiereItemTypes';
import { getItemLocalDirs } from '@mimir/client-common/util/folder';
import type { LoadedItem, ClientItem } from '@mimir/common/dto/searchResultHit';
import { isInstanceOfVirtualClip } from '@mimir/common/dto/virtualClipUtil';
import isEmpty from 'lodash/isEmpty';
import { getItemAncestry } from '@mimir/web/api/globalClientFolder';
export const getItemWithSourceMedia = (item: Pick<ClientItem, 'virtualClipInfo' | 'aaf'> & ItemWithSourceMedia): ItemWithSourceMedia => {
  // Virtual clips of AAF items are imported as separate subclips and as such are independent of the master clips
  return isInstanceOfVirtualClip(item.virtualClipInfo) && !item.aaf
    ? {
      id: item.virtualClipInfo.masterClipId,
      originalFileName: item.originalFileName,
      folderParents: item.folderParents,
      ingestSourceFullPath: item.ingestSourceFullPath,
      ingest: item.ingest,
      itemState: item.itemState
    }
    : item;
};

export const getSrtLocalPath = async (item: LoadedItem, ext: string, timeRangePrefix: string, pathSep: string) => {
  const store = getGlobalStore();
  // as we can't rely on item.localDir to be available at the moment of executing this code, we
  // are making a network call here to make sure subtitle import does not fail.
  const downloadPath = store.getters.downloadPath;
  const localDirs = await getItemLocalDirs(item, downloadPath, pathSep,
    (itemId) => getItemAncestry(itemId, undefined));

  // we append a timestamp since Premiere seems to lock srt files for no reason, and also we can have changed srt/translation
  const itemLocalDir = isEmpty(localDirs) ? '' : localDirs[0];
  if (isEmpty(itemLocalDir)) {
    return `${store.getters.downloadPath}${pathSep}${timeRangePrefix}${item.id}_${+new Date()}.${ext}`;
  }

  const hasFolderParent = !isEmpty(localDirs);
  const highResLocalPath = `${itemLocalDir}${pathSep}${timeRangePrefix}${hasFolderParent ? item.originalFileName : item.id}_${+new Date()}.${ext}`;

  return highResLocalPath;
};
